import { apply, put } from 'redux-saga/effects';
import {
  track as trackAction,
  Events,
  Categories,
  quantumMetricClient,
} from '@app/analytics';
import ironLegacyClient from '@app/data/ironLegacyClient';

import { removeItem } from '@app/redux/profile/actions';
import { track as trackHelper } from './helpers';
import {
  setPortfolioItem,
  setNewPortfolioItem,
  setPortfolioItemError,
} from './actions';
import handleError from '../utils/get-error-message';

export const onFetchPortfolioItem = function* onFetchPortfolioItem({
  payload: { chainId, params },
}) {
  try {
    const res = yield apply(
      ironLegacyClient,
      ironLegacyClient.getPortfolioItem,
      [chainId, params],
    );

    const { PortfolioItem } = res.body;
    yield put(setPortfolioItem(PortfolioItem));
  } catch (e) {
    setPortfolioItemError(handleError(e));
  }
};

export const onPostPortfolioItem = function* onPostPortfolioItem({
  payload: {
    action,
    data,
    paymentMethod,
    product,
    isGlobalNotificationEmailEnabled,
  },
}) {
  try {
    const { item } = data;
    const res = yield apply(
      ironLegacyClient,
      ironLegacyClient.postPortfolioItem,
      [action, data],
    );

    const { PortfolioItem } = res.body;
    yield put({ type: 'POST_PORTFOLIO_ITEM', data: PortfolioItem });
    yield put(setNewPortfolioItem(PortfolioItem));
    yield trackHelper(
      PortfolioItem,
      action,
      item,
      product,
      paymentMethod,
      isGlobalNotificationEmailEnabled,
    );
    yield quantumMetricClient.trackGenericError(
      `portfolio item created with chainID ${PortfolioItem?.chainId}`,
    );
  } catch (e) {
    // On occasion, backend fails to deliver an error response at all.
    yield put(
      // @ts-expect-error
      setPortfolioItemError(e?.response?.body || 'An error has occurred.'),
    );
  }
};

export const onDeletePortfolioItem = function* onDeletePortfolioItem({
  payload: { id, notes },
}) {
  try {
    yield put(setPortfolioItemError(null));
    yield apply(ironLegacyClient, ironLegacyClient.deletePortfolioItem, [
      id,
      notes,
    ]);
    yield put(removeItem({ chainId: id }));
  } catch (e) {
    // @ts-expect-error
    yield put(setPortfolioItemError(e.message));
  }
};

export const onSetLastClickedPortfolioItem =
  function* onSetLastClickedPortfolioItem() {
    const event = Events.basCellClick;
    const properties = {
      category: Categories.MultiAsk,
      label: Events.basCellClick,
    };

    yield put(trackAction({ event, properties }));
  };

export const onTrackPortfolioItem = function* onTrackPortfolioItem({
  payload: { portfolioItem, action, item, product, paymentMethod },
}) {
  yield trackHelper(portfolioItem, action, item, product, paymentMethod);
};
